import Header from './components/Header.tsx';
import HeroSection from './components/HeroSection.tsx';
import AboutSection from './components/AboutSection.tsx';
import SkillsSection from './components/SkillsSection.tsx';
import ContactSection from './components/ContactSection.tsx';
import Footer from './components/Footer.tsx';
import './App.css';

function App() {
  return (
    <div className="app-shell">
      <div className="app-background" aria-hidden="true">
        <span className="glow glow-one" />
        <span className="glow glow-two" />
        <span className="grid-overlay" />
      </div>
      <Header />
      <main className="app-main">
        <HeroSection />
        <AboutSection />
        <SkillsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
